import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';
import { IManualEventOverrides } from '@faire/web--source/common/pete/types';

export const eventKey = 'infra-user_perceived_load_timing-timing';

/**
 * General event for capturing the User Perceived Load Time (UPLT) metric
 */
export function trackInfraUserPerceivedLoadTimingTiming(
  name: string,
  isInitialLoad2: string,
  status3: string,
  manualOverrides?: IManualEventOverrides
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: true,
    manualOverrides,
    startTrace: true,
    parameters: { name, isInitialLoad2, status3 },
  });
}

/**
 * Trace for event: infra-user_perceived_load_timing-timing
 */
export function trackInfraUserPerceivedLoadTimingTimingTraceImagesloaded(
  name: string,
  isInitialLoad2: string,
  status3: string,
  sourceEventMarker?: ITraceEventMarker,
  manualOverrides?: IManualEventOverrides
): void {
  trackClientEvent({
    eventKey: 'infra-user_perceived_load_timing-timing-trace-imagesloaded',
    realTimeTracking: true,
    manualOverrides,
    sourceEventKey: 'infra-user_perceived_load_timing-timing',
    sourceEventMarker,
    parameters: { name, isInitialLoad2, status3 },
  });
}

/**
 * Trace for event: infra-user_perceived_load_timing-timing
 */
export function trackInfraUserPerceivedLoadTimingTimingTraceMeasurementcompleted(
  name: string,
  isInitialLoad2: string,
  status3: string,
  isNextJS4: string = 'false',
  traceId5: string = '',
  appSource6: string = 'unknown',
  sourceEventMarker?: ITraceEventMarker,
  manualOverrides?: IManualEventOverrides
): void {
  trackClientEvent({
    eventKey:
      'infra-user_perceived_load_timing-timing-trace-measurementcompleted',
    realTimeTracking: true,
    manualOverrides,
    endTrace: true,
    sourceEventKey: 'infra-user_perceived_load_timing-timing',
    sourceEventMarker,
    parameters: {
      name,
      isInitialLoad2,
      status3,
      isNextJS4,
      traceId5,
      appSource6,
    },
  });
}

/**
 * Trace for event: infra-user_perceived_load_timing-timing
 */
export function trackInfraUserPerceivedLoadTimingTimingTracePageready(
  customParameterToken: string,
  isInitialLoad2: string,
  status3: string,
  isNextJS4: string = 'false',
  traceId5: string = '',
  appSource6: string = 'unknown',
  sourceEventMarker?: ITraceEventMarker,
  manualOverrides?: IManualEventOverrides
): void {
  trackClientEvent({
    eventKey: 'infra-user_perceived_load_timing-timing-trace-pageready',
    realTimeTracking: true,
    manualOverrides,
    sourceEventKey: 'infra-user_perceived_load_timing-timing',
    sourceEventMarker,
    parameters: {
      customParameterToken,
      isInitialLoad2,
      status3,
      isNextJS4,
      traceId5,
      appSource6,
    },
  });
}

/**
 * Trace for event: infra-user_perceived_load_timing-timing
 */
export function trackInfraUserPerceivedLoadTimingTimingTraceQuietmainthread(
  name: string,
  isInitialLoad2: string,
  status3: string,
  sourceEventMarker?: ITraceEventMarker,
  manualOverrides?: IManualEventOverrides
): void {
  trackClientEvent({
    eventKey: 'infra-user_perceived_load_timing-timing-trace-quietmainthread',
    realTimeTracking: true,
    manualOverrides,
    sourceEventKey: 'infra-user_perceived_load_timing-timing',
    sourceEventMarker,
    parameters: { name, isInitialLoad2, status3 },
  });
}

/**
 * Trace for event: infra-user_perceived_load_timing-timing
 */
export function trackInfraUserPerceivedLoadTimingTimingTraceUserinteracted(
  name: string,
  isInitialLoad2: string,
  sourceEventMarker?: ITraceEventMarker,
  manualOverrides?: IManualEventOverrides
): void {
  trackClientEvent({
    eventKey: 'infra-user_perceived_load_timing-timing-trace-userinteracted',
    realTimeTracking: true,
    manualOverrides,
    sourceEventKey: 'infra-user_perceived_load_timing-timing',
    sourceEventMarker,
    parameters: { name, isInitialLoad2 },
  });
}
